import FasterEvent from '../fasterEvent'

/**
 * Fired when an inbound VIU `?hash=` (whether from our own outbound HE redirect or a direct-hash
 * landing, e.g. a partner "Continue on Web" link) fails to decrypt/parse, and we fall back to the
 * HE gateway redirect (`maybeRedirectViuClient`) instead of failing the request outright.
 *
 * `countryCode` / `carrier` are best-effort (from cached IP geo / URL override) — may be empty if
 * unresolved at the time of failure. `fallbackTriggered` distinguishes "fell back successfully" from
 * "fallback unavailable, showed error" (e.g. desktop browser, no eligible region).
 */
export default new FasterEvent(
  { id: 'viu_hash_decode_fallback', revision: 0 },
  (eventBuilder, parameters) => {
    return eventBuilder
      .dimension('countryCode', parameters.countryCode || '')
      .dimension('carrier', parameters.carrier || '')
      .dimension('fallbackTriggered', String(Boolean(parameters.fallbackTriggered)))
      .build()
  }
)
